import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
} from '../../components'
import Styles from './FooterPartner.css'

@CSSModules(Styles)
export default class FooterPartner extends Component {
  render() {
    const iyvLogo = require( '../../../static/images/iyv-logo-sm.png' )
    //
    return <div styleName='footer-partner'>
      <Link
        to={config.links.iyv}
        title='Invest Your Values'
      >
        <img
          styleName='footer-partner__img'
          src={iyvLogo}
          alt='Invest Your Values'
        />
      </Link>
    </div>
  }
}
